module.exports = __webpack_public_path__ + "img/vimeo-embed.e413238c.png";